<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="card mx-auto col-8 border-0">
      <div class="card-title">
        <div class="row" style="padding-left: 10px;">
          <div class="survey-type-badge bg-default">
            <span class="icon-bullet-list" />
          </div>
          <div class="col-8">
            <strong>GDQ: </strong>Volvo Mätning 1 - Contact Members
            <p style="font-size: 0.7em;">
              <span class="icon-users" />&nbsp;Volvo Ledningsgrupp
            </p>
          </div>
        </div>
      </div>
      <h4>Select Message</h4>
      <div class="mb-3">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="message" id="message-invitation" value="invitation">
          <label class="form-check-label" for="message-invitation">
            Send the invitation message
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="message" id="message-reminder" value="reminder">
          <label class="form-check-label" for="message-reminder">
            Send a reminder
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="message" id="message-adhoc" value="adhoc">
          <label class="form-check-label" for="message-adhoc">
            Create and send a new message
          </label>
        </div>
      </div>
      <h4>Select Members</h4>
      <p>Please select the members you wish to contact from the list below</p>
      <GroupMembers />
    </div>
  </div>
</template>

<script setup>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import GroupMembers from './GroupMembers.vue'

defineOptions({ name: 'ContactGroupMembers' })
</script>

<style scoped>
</style>
